import React from 'react';
import { FaApple, FaGoogle } from "react-icons/fa";
import { FcGoogle } from "react-icons/fc";

const style = {
  // backgroundColor: '#ffffff',
    backgroundColor: '#4c8bf5',
    color: '#ffffff',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    padding: '0.55rem 0.55rem'
};

const buttonTextStyle={
  flexGrow: 1
}

const iconStyle = {
    backgroundColor: '#ffffff',
    borderRadius: '50%',
    fontSize: '25px'
};


const GoogleSignInButton = props => {
  return (
    <button style={style} className="btn" onClick={props.onClick} disabled={props.disabled}><FcGoogle style={iconStyle} /><span style={buttonTextStyle}>Sign In with Google</span></button>
  );
};

export default GoogleSignInButton;
